import React, { FC } from 'react';
import cn from 'classnames';
import { popupLayoutCssPostfix } from '../../types';
import { usePopupContext } from '../../contexts/Settings';

type Props = {
  clickable?: boolean;
  className?: string;
};

const Title: FC<Props> = ({ children, clickable, className = '' }) => {
  const { settings } = usePopupContext();

  return (
    <div
      className={cn(
        `${className} Product-Title${popupLayoutCssPostfix(
          settings,
        )} font-semibold max-w-full text-md text-grey-1 pr-10 md:pr-none`,
        clickable && 'cursor-pointer transition-colors duration-100',
      )}
    >
      {children}
    </div>
  );
};
export default Title;
